module.exports = __webpack_public_path__ + "1792395595471/images/no-data.6265e46.svg";